import { createI18n } from 'vue-i18n'
import en from '@/localization/en.json'
import es from '@/localization/es.json'
import no from '@/localization/no.json'
import pt from '@/localization/pt.json'
import tr from '@/localization/tr.json'
// import appsettings from '@/configs/appsettings'

const i18n = createI18n({
    locale: () => window.appsettings.AppGlobal.DefaultLanguage,
    messages: {
        EN: en,
        ES: es,
        NO: no,
        PT: pt,
        TR: tr
    }
})

export default i18n


